import React from 'react';
import { Card, Link, PillButton, Row, Text } from 'library/ui';
import { usePostJobNavigation } from 'parent-portal/jobs/postJob/usePostJobNavigation';
import type { IProviderSearch } from '../ProvidersSearchAndFilter/models';

export default function StaffSendJob({
    selectedProviders,
    resetSelectedProviders,
}: {
    selectedProviders: IProviderSearch[];
    resetSelectedProviders: () => void;
}) {
    const { goToPostJob } = usePostJobNavigation();

    if (selectedProviders.length === 0) return null;

    function postJob() {
        const requestedWorkers = selectedProviders.map((provider) => ({
            id: provider.user.id,
            name: [provider.user.first_name, provider.user.last_name].filter(Boolean).join(' '),
        }));
        resetSelectedProviders();
        goToPostJob('Staff List', { requestedWorkers });
    }

    return (
        <Card tone="muted" padding="sm">
            <Row gap="md" align="center">
                <Text weight="semibold">{selectedProviders.length} selected</Text>
                <PillButton onClick={postJob}>Post Job</PillButton>
                <Link onClick={resetSelectedProviders} underline={false}>
                    Clear
                </Link>
            </Row>
        </Card>
    );
}
